import { render, staticRenderFns } from "./PreOrderMaterials.vue?vue&type=template&id=7cb86a10&scoped=true&"
import script from "./PreOrderMaterials.vue?vue&type=script&lang=js&"
export * from "./PreOrderMaterials.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderMaterials.vue?vue&type=style&index=0&id=7cb86a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb86a10",
  null
  
)

component.options.__file = "PreOrderMaterials.vue"
export default component.exports